import { z } from "zod";

// Base response schema with Zod validation
export const BaseRespSchema = z.object({
  success: z.boolean(),
  status: z.number(),
  code: z.string(),
  message: z.string(),
  timestamp: z.string().datetime()
});
export type BaseResp = z.infer<typeof BaseRespSchema>;

// Generic response schema for data
export const ApiRespSchema = <T extends z.ZodTypeAny>(dataSchema: T) =>
  BaseRespSchema.extend({
    data: dataSchema.optional(),
    error: z.string().optional()
  });
export type ApiResp<T> = BaseResp & {
  data?: T;
  error?: string;
};

// Error response schema
export const ErrorRespSchema = BaseRespSchema.extend({
  error: z.string(),
  details: z.record(z.any()).optional(),
  stack: z.string().optional()
});
export type ErrorResp = z.infer<typeof ErrorRespSchema>;
